<template>
  <div>
    <!-- header -->
    <b-container fluid class="sticky-top" style="z-index: 4!important;">
      <b-row align-h="between" class="top-shelf py-2">
        <b-col lg="2" sm="2">
          <b-link class="ml-3" @click="$router.push('/app/prod/inventario')">
            <font-awesome-icon :icon="['far', 'chevron-left']" size="lg" />
            <span class="pl-2">Atrás</span>
          </b-link>
        </b-col>
        <b-col v-if="ready" lg="8" sm="8" class="pt-3">
          <h4>
            <div v-if="!item.is_bundle" class="text-secondary">
              <font-awesome-icon :icon="['far', 'warehouse-alt']" size="lg" fixed-width />
              <span class="pl-1">Artículo: {{ item.item_code }}</span>
            </div>
            <div v-else class="text-warning">
              <font-awesome-icon :icon="['far', 'boxes-alt']" size="lg" />
              <span class="pl-1">Bulto: {{ item.item_code }}</span>
            </div>
          </h4>
        </b-col>
        <b-col v-if="ready" lg="2" sm="2" class="text-right">
          <b-img-lazy v-if="itemPhotos.length > 0 && coverPhotoUrl" rounded="circle" fluid :src="coverPhotoUrl" class="m-1 header-foto" alt="photo"></b-img-lazy>
        </b-col>
      </b-row>
    </b-container>
    <!-- Content -->
    <ContentView v-if="ready">
      <b-row class="mb-2" align-h="between">
        <b-col cols="3">
          <h4 class="text-primary">General</h4>
        </b-col>
        <b-col cols="9" class="text-right">
          <Button
            v-if="isDev"
            variant="outline-light"
            size="sm"
            :disabled="processing || fetchingProduct || pendingResult || fetchingSapProduct"
            @click="fetchSapProduct"
          >
            <div v-if="fetchingSapProduct || pendingResult">
              <b-spinner small type="grow" class="text-muted mr-2"></b-spinner>
              Sincronizando
            </div>
            <span v-else class="pl-2">Sincronizar</span>
          </Button>
          <WarehouseDataWidget v-if="item.is_valid" :is-distribution="isDistributor" :is-installation="isInstaller" :item="item" @item-stock-updated="updateItemStock" />
          <PurchaseOrderDataWidget v-if="item.is_valid && !isDistributor && !isInstaller" :item="item" />
        </b-col>
      </b-row>
      <!-- General info -->
      <b-row id="general_item_info" class="pl-2">
        <b-col cols="12">
          <b-table-simple small class="border-bottom">
            <b-tbody>
              <b-tr v-if="isAdmin">
                <b-th style="width: 350px;">Estado:</b-th>
                <b-td v-if="item.is_valid">
                  <span class="text-success pr-1">Activo</span>
                  <font-awesome-icon :icon="['fas', 'dot-circle']" fixed-width class="text-success" />
                </b-td>
                <b-td v-else>
                  <span class="text-danger pr-1">Inactivo</span>
                  <font-awesome-icon :icon="['fas', 'dot-circle']" fixed-width class="text-danger" />
                </b-td>
              </b-tr>
              <!-- Item code -->
              <b-tr class="d-lg-none">
                <b-td colspan="2">
                  <strong class="mb-1">Código artículo:</strong><br>
                  <p class="text-left mb-0">{{item.item_code}}</p>
                </b-td>
              </b-tr>
              <b-tr class="d-none d-lg-table-row">
                <b-th style="width: 350px;">Código artículo:</b-th>
                <b-td>{{item.item_code}}</b-td>
              </b-tr>
              <!-- Product type -->
              <b-tr class="d-lg-none">
                <b-td colspan="2">
                  <strong class="mb-1">Categoría:</strong><br>
                  <p v-if="item.type_name" class="text-left mb-0">{{item.type_name}}</p>
                  <p class="text-muted text-left mb-0" v-else>pendiente</p>
                </b-td>
              </b-tr>
              <b-tr class="d-none d-lg-table-row">
                <b-th style="width: 350px;">Categoría:</b-th>
                <b-td>
                  <span v-if="item.type_name">{{item.type_name}}</span>
                  <span class="text-muted" v-else>pendiente</span>
                </b-td>
              </b-tr>
              <!-- Item group -->
              <b-tr class="d-lg-none">
                <b-td colspan="2">
                  <strong class="mb-1">Grupo:</strong><br>
                  <p v-if="item.item_group" class="text-left mb-0">{{item.item_group.name}}</p>
                  <p class="text-muted text-left mb-0" v-else>pendiente</p>
                </b-td>
              </b-tr>
              <b-tr class="d-none d-lg-table-row">
                <b-th style="width: 350px;">Grupo:</b-th>
                <b-td>
                  <span v-if="item.item_group">{{item.item_group.name}}</span>
                  <span class="text-muted" v-else>pendiente</span>
                </b-td>
              </b-tr>
              <!-- Public Price -->
              <b-tr class="d-lg-none">
                <b-td colspan="2">
                  <strong class="mb-1">Precio público:</strong><br>
                  <span v-if="item.price_currency == 'USD'">
                    <span v-if="isInstaller">{{ convertToColones(item.price) | colones2 }}</span>
                    <span v-else>{{ item.price | dollarize }}</span>
                  </span>
                  <span v-else-if="item.price_currency == 'COL'">
                    <span>{{ item.price | colones2 }}</span>
                  </span>
                  <span v-else>{{ item.price_currency }} {{ item.price }}</span>
                </b-td>
              </b-tr>
              <b-tr class="d-none d-lg-table-row">
                <b-th style="width: 350px;">Precio público:</b-th>
                <b-td>
                  <span v-if="item.price_currency == 'USD'">
                    <span v-if="isInstaller">{{ convertToColones(item.price) | colones2 }}</span>
                    <span v-else>{{ item.price | dollarize }}</span>
                  </span>
                  <span v-else-if="item.price_currency == 'COL'">
                    <span>{{ item.price | colones2 }}</span>
                  </span>
                  <span v-else>{{ item.price_currency }} {{ item.price }}</span>
                </b-td>
              </b-tr>
              <!-- Stock -->
              <b-tr v-if="!isDistributor && !isInstaller" class="d-lg-none">
                <b-td colspan="2">
                  <strong class="mb-1">Stock de bodega principal (01):</strong><br>
                  <p class="text-left mb-0">{{item.stock}}</p>
                </b-td>
              </b-tr>
              <b-tr v-if="!isDistributor && !isInstaller" class="d-none d-lg-table-row">
                <b-th style="width: 350px;">Stock de bodega principal (01):</b-th>
                <b-td>{{item.stock}}</b-td>
              </b-tr>
              <b-tr v-if="!isDistributor && !isInstaller" class="d-none d-lg-table-row">
                <b-th style="width: 350px;">Cantidad solicitada:</b-th>
                <b-td>{{item.ordered_quantity}}</b-td>
              </b-tr>
              <!-- Cabys code -->
              <b-tr class="d-lg-none">
                <b-td colspan="2">
                  <strong class="mb-1">Código cabys:</strong><br>
                  <p v-if="item.sap_cabys_code" class="mb-0">{{ item.sap_cabys_code }}</p>
                  <p v-else class="text-secondary font-weight-bold mb-0">
                    <span class="mb-2">pendiente</span>
                    <font-awesome-icon :icon="['far', 'info-circle']" size="sm"/>
                  </p>
                </b-td>
              </b-tr>
              <b-tr class="d-none d-lg-table-row">
                <b-th style="width: 350px;">Código cabys:</b-th>
                <b-td v-if="item.sap_cabys_code">{{item.sap_cabys_code}}</b-td>
                <b-td v-else>
                  <div class="text-secondary font-weight-bold">
                    <span class="mb-2">pendiente</span>
                    <font-awesome-icon :icon="['far', 'info-circle']" size="sm"/>
                  </div>
                </b-td>
              </b-tr>
              <!-- Description -->
              <b-tr class="d-lg-none">
                <b-td colspan="2">
                  <strong class="mb-1">Descripción corta:</strong><br>
                  {{ item.description }}
                </b-td>
              </b-tr>
              <b-tr class="d-none d-lg-table-row">
                <b-th style="width: 350px;">Descripción corta:</b-th>
                <b-td>{{item.description}}</b-td>
              </b-tr>
              <!-- Description lg -->
              <b-tr class="d-lg-none">
                <b-td colspan="2">
                  <strong class="mb-1">Descripción completa:</strong><br>
                  {{ item.description_lg }}
                </b-td>
              </b-tr>
              <b-tr class="d-none d-lg-table-row">
                <b-th style="min-width: 270px;">Descripción completa:</b-th>
                <b-td>
                  {{ item.description_lg }}
                </b-td>
              </b-tr>
              <!-- Product leader -->
              <b-tr class="d-lg-none">
                <b-td colspan="2">
                  <strong class="mb-1">Líder de producto:</strong><br>
                  {{ item.product_leader }}
                </b-td>
              </b-tr>
              <b-tr class="d-none d-lg-table-row">
                <b-th style="width: 350px;">Líder de producto:</b-th>
                <b-td>{{item.product_leader}}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
      <!-- bundle items -->
      <b-row v-if="ready && item.is_bundle" class="pl-2">
        <b-col cols="3" class="pl-4">
          <b>Artículos bulto:</b>
        </b-col>
        <b-col class="ml-4">
          <div v-if="item.bundle_items.length > 0">
            <ul v-for="bundle in item.bundle_items" :key="bundle.id" class="mb-0">
              <li>{{ bundle.quantity }} {{ bundle.subproduct.item_code }}</li>
            </ul>
          </div>
          <div v-else>
            <span class="text-danger">Esté bulto no tiene artículos</span>
          </div>
        </b-col>
      </b-row>
      <b-row align-content="end">
        <b-col class="text-right">
          <p class="float-right w-100 mb-2 text-info fs-14" v-if="isDev">Ultima actualización: {{ item.updated_at | formatDateTime }}</p>
        </b-col>
      </b-row>
      <b-row v-if="ready && !item.is_bundle">
        <b-col>
          <b-tabs
            v-model="tabIndex"
            content-class="mt-1"
            nav-class="font-weight-bold fs-18"
            active-nav-item-class="text-primary fs-20 font-weight-bold border-bottom-0"
          >
            <!-- Images -->
            <b-tab
              :title="`Imágenes (${itemPhotos.length})`"
              :active="tabIndex == 0"
            >
              <ItemImages
                v-if="tabIndex == 0"
                :product-id="id"
                :cover-photo-id="item.cover_photo_id"
                :images="itemPhotos"
                @set-photos="setPhotos"
                @update-cover-photo="handleUpdateCoverPhoto"
                @add-photo="handleAddPhoto"
                @delete-photo="handleDeletePhoto"
                @display-alert="displayAlert"
              />
            </b-tab>
            <!-- Documents -->
            <b-tab
              :title="`Documentos (${itemDocuments.length})`"
              :active="tabIndex == 1"
            >
              <ItemDocuments
                v-if="tabIndex == 1"
                :product-id="id"
                :documents="itemDocuments"
                :loading="fetchingProduct"
                @add-document="handleAddDocument"
                @delete-document="handleDeleteDocument"
                @display-alert="displayAlert"
              />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </ContentView>

    <!-- Alert -->
    <ToastAlert :show="alertShow" :variant="alertVariant" @close="alertShow = false">
      {{ alertMessage }}
    </ToastAlert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { normalize, schema } from 'normalizr'

import ItemImages from './ItemImages'
import ItemDocuments from './ItemDocuments'
import ContentView from '../../shared/ContentView'
import WarehouseDataWidget from '../../shared/WarehouseDataWidget'
import PurchaseOrderDataWidget from '../../shared/PurchaseOrderDataWidget'

import ToastAlert from '../../shared/ToastAlert'
import Button from '../../shared/Button'

export default {
  name: 'ItemShow',
  components: {
    ContentView,
    WarehouseDataWidget,
    PurchaseOrderDataWidget,
    ToastAlert,
    Button,
    ItemDocuments,
    ItemImages
  },
  data () {
    return {
      id: Number(this.$route.params.id),
      item : [],
      photoData: {},
      photoList: [],
      photoSlide: 0,
      photoSliding: null,
      processing: false,
      fetchingProduct: false,
      ready: false,
      bTabIndex: 0,
      alertShow: false,
      alertVariant: null,
      alertMessage: '',
      fetchingSapProduct: false,
      pendingResult: false,
      retryPingCount: 0,
      tabIndex: 0,
      documentData: {},
      documentList: []
    }
  },
  mounted () {
    this.fetchItemData()
  },
  computed : {
    ...mapGetters (['isAdmin' ,'isDistributor', 'isInstaller', 'usdCrRate', 'isDev']),
    itemPhotos() {
      return this.photoList.map(id => this.photoData[id])
    },
    coverPhotoUrl() {
      if (this.photoList.find(id => id === this.item.cover_photo_id)) {
        return this.photoData[this.item.cover_photo_id].img_url
      }
      return ''
    },
    itemDocuments() {
      return this.documentList.map(id => this.documentData[id])
    }
  },
  methods : {
    fetchItemData () {
      if (this.fetchingProduct) { return }
      this.ready = false
      this.fetchingProduct = true
      this.$http.get(`/api/production/products/${this.id}`)
        .then((resp) => {
          // console.log(resp.data)
          this.item = resp.data
          this.setPhotos({
            photos: resp.data.photos,
            coverPhotoId: resp.data.cover_photo_id
          })
          this.setDocuments(resp.data.documents)
          delete this.item.photos
          delete this.item.documents
          this.ready = true
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.fetchingProduct = false
        })
    },
    updateItemStock ({ stock, ordered_quantity }) {
      this.item.stock = stock
      this.item.ordered_quantity = ordered_quantity
      // this.$set(this.itemData, this.selectedItem.id, this.selectedItem)
    },
    // Photos
    setPhotos ({photos, coverPhotoId}) {
      this.item.cover_photo_id = coverPhotoId
      const data = normalize(
        { photos: photos },
        { photos: [ new schema.Entity('photos') ] }
      )
      if (data.entities.hasOwnProperty('photos')) {
        this.photoData = data.entities.photos
      }
      this.photoList = data.result.photos
    },
    handleUpdateCoverPhoto (id) {
      this.item.cover_photo_id = id
    },
    handleAddPhoto (createdPhoto) {
      this.item.photos_count++
      if (this.photoList.length == 0) {
        this.item.cover_photo_id = createdPhoto.id
      }
      this.photoList.unshift(createdPhoto.id)
      this.$set(this.photoData, createdPhoto.id, createdPhoto)

      this.displayAlert({
        message: 'Imagen creada exitosamente',
        variant: 'success'
      })
    },
    handleDeletePhoto (deletePhotoId) {
      this.item.photos_count--
      if (this.item.cover_photo_id == deletePhotoId) {
        this.item.cover_photo_id = null
      }
      delete this.photoData[deletePhotoId]
      this.photoList = this.photoList.filter(id => id !== deletePhotoId)
      this.displayAlert({
        message: 'Imagen eliminada',
        variant: 'success'
      })
    },
    // documents
    setDocuments (documents) {
      const data = normalize(
        { documents: documents },
        { documents: [ new schema.Entity('documents') ] }
      )
      if (data.entities.hasOwnProperty('documents')) {
        this.documentData = data.entities.documents
      }
      this.documentList = data.result.documents
    },
    handleAddDocument(createdDocument) {
      this.$set(this.documentData, createdDocument.id, createdDocument)
      this.documentList.push(createdDocument.id)
      this.displayAlert({
        message: 'Documento creado exitosamente',
        variant: 'success'
      })
    },
    handleDeleteDocument(deletedDocumentId) {
      this.documentList = this.documentList.filter(id => id !== deletedDocumentId)

      delete this.documentData[deletedDocumentId]
      this.displayAlert({
        message: 'Documento eliminado',
        variant: 'success'
      })
    },
    convertToColones (dollarValue){
      return dollarValue * this.usdCrRate
    },
    fetchSapProduct () {
      if (this.fetchingSapProduct) { return }
      const lastUpdated = Math.floor((new Date() - new Date(this.item.updated_at)) / 60000)
      if (lastUpdated < 5) {
        this.displayAlert({
          message: 'Producto recientemente sincronizado con SAP hace ' + lastUpdated + ' minutos',
          variant: 'success'
        })
        return
      }
      this.fetchingSapProduct = true
      this.$http.get(`/api/production/products/${this.id}/fetch_sap_product`, {
        params: {
          fetch_sap: true
        }
      })
        .then((resp) => {
          const { success, item } = resp.data
          if (success) {
            this.item = item
            delete this.item.photos
            this.displayAlert({
              message: 'Producto recientemente sincronizado',
              variant: 'success'
            })
          } else {
            this.pendingResult = true
            setTimeout(() => this.ping(), 5000)
          }
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.fetchingSapProduct = false
        })
    },
    ping () {
      if (this.fetchingSapProduct) { return }
      this.fetchingSapProduct = true
      this.$http.get(`/api/production/products/${this.id}/fetch_sap_product`, {
        params: {
          // wait 25 seconds before pinging again to sap
          fetch_sap: this.retryPingCount == 5 ? true : false
        }
      })
      .then((res) => {
        const { success, item } = res.data
        if (success) {
          this.item = item
          this.pendingResult = false
          delete this.item.photos
          this.displayAlert({
              message: 'Producto sincronizado con éxito',
              variant: 'success'
            })
        } else {
          this.retryPingCount+=1
          if (this.retryPingCount == 10) {
            this.pendingResult = false
            this.retryPingCount = 0
            this.displayAlert({
              message: 'No se pudo sincronizar con SAP, intente nuevamente',
              variant: 'danger'
            })
            return
          }
          setTimeout(() => this.ping(), 5000)
        }
      })
      .catch(e => console.log(e))
      .finally(() => {
        this.fetchingSapProduct = false
      })
    },
    displayAlert ({ message, variant }) {
      if (this.alertShow) return
      this.alertVariant = variant
      this.alertMessage = message
      this.alertShow = true
    }
  }
}
</script>

<style scoped>
.header-foto {
  height: 5rem;
  width: 5rem;
  border-radius: 100%;
}
</style>